import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
import PAA from '../../blocks/PhoneAndAddress';
import Title from '../../blocks/Title'
import MyIcons from '../../blocks/MyIcons'
import {LangChangeEventContext} from '../../contexts/LangContext';



export default class Contacts extends Component {
  componentWillMount(){
   
  }
  componentDidMount(){
    this.props.getHeightContent(this.conBody.offsetHeight);
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
          // <div className={styles['aboutWrapper']} >  
            <div className={classNames(styles['contactsBody'], 
              this.props.steps[1] && styles['is-step1'], 
              this.props.steps[2] && styles['is-step2'], 
              this.props.steps[3] && styles['is-step3'], 
              this.props.steps[4] && styles['is-step4'], 
              this.props.steps[5] && styles['is-step5'], 
              this.props.steps[6] && styles['is-step6'], 
              this.props.steps[7] && styles['is-step7'], 
              this.props.steps[8] && styles['is-step8'], 
              this.props.steps[9] && styles['is-step9'])
            } 
              style={{transform:'translateY('+this.props.valueScroll+'px)'}}
            >  
              <div className={classNames(styles['backgroundImgWrapper'])} >  
                {/* <img alt="" src="/assets/img/c-bg.png" className={styles['backgroundImg']} />                   */}
                <img alt="" src={ this.props.ADMIN_URL+this.props.data.bg } className={styles['backgroundImg']} />   
                <div className={classNames(styles['backgroundGradient'])} > </div>                 
                <div className={classNames(styles['backgroundLogoWrapper'])} >  
                  <img alt="" src="/assets/logo.jpg" className={styles['backgroundLogoImg']} />  
                </div>
              </div>

              <div className={classNames(styles['contentWrapper'])} 
              //  style={{transform:'translateY('+this.props.valueScroll+'px)'}}
               >
                <div className={classNames(styles['header'])}>
                  <PAA classStyle={styles['paaStyle']} iconPlace='place-dark' iconPhone='phone-dark' colorStyle="black1"/>
                  <Title classStyle={styles['titleStyle']} colorStyle="black1"  title={lang.t('contactsHeader')} text={lang.t('contactsSubHeader')}/>
                </div>
                <div className={classNames(styles['content'])}  ref={item => {this.conBody = item}}>  
                  <div className={styles['wrapperText']} >  
                    <h3 className={styles['wrapperTextTitle']}>{lang.t('contactsAbout')}</h3>
                    <div className={styles['text']} >
                      <table className={styles['table']}>
                        <thead> 
                          <tr>
                            <th className={styles['tableTH']}>{lang.t('contactsBreakfast')}</th>
                            <th className={styles['tableTH']}>{lang.t('contactsCards')}</th>
                            <th className={styles['tableTH']}>{lang.t('contactsDiscount')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className={classNames(styles['tableTD'],styles['tableTD_brek'])}>{lang.t('contactsBreakfastV')}</td>
                            <td className={styles['tableTD']}>{lang.t('contactsCardsV')}</td>
                            <td className={classNames(styles['tableTD'],styles['tableTD_disc'])}>{lang.t('contactsDiscountV')}</td>
                          </tr>
                        </tbody>
                      </table>
                      <table className={styles['table2']}>
                        <thead>
                          <tr>
                            <th className={styles['tableTH']}>{lang.t('contactsP')}</th>
                            <th className={styles['tableTH']}>{lang.t('contactsLunch')}</th>
                            <th className={styles['tableTH']}>{lang.t('contactsKids')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className={styles['tableTD']}>{lang.t('contactsPV')}</td>
                            <td className={styles['tableTD']}>{lang.t('contactsLunchV')}</td>
                            <td className={styles['tableTD']}>{lang.t('contactsKidsV')}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className={styles['spoon']} >
                      <MyIcons icon="spoon" width="100px" height="100px"/>
                    </div>
                    <h3 className={styles['wrapperTextTitle2']}>{lang.t('contactsInfo')}</h3>
                    <div className={styles['text2']}> 
                      <div className={styles['blockText']}> 
                        {lang.t('contactsAddress')}<br/>
                        {lang.t('contactsAddressV')}
                      </div>
                      <div className={styles['blockText']}> 
                        {lang.t('contactsWorkTime')}<br/>
                        {lang.t('contactsWorkTimeV')}
                      </div>
                      <div className={styles['blockText']}> 
                        {lang.t('contactsMetro')}<br/>
                        {lang.t('contactsMetroV')}
                      </div>                      
                      <div className={styles['blockText']}> 
                        {lang.t('contactsPhone')}<br/>
                        <a className={styles['phoneLink']} href={'tel:'+lang.t('contactsPhoneLink')}>{lang.t('contactsPhoneV')}</a>
                      </div>
                    </div>
                  </div>
                  
                  <div className={styles['galleryWrapper']} id="mymap" dangerouslySetInnerHTML={{__html: this.props.data.map }} >
                  </div>
                </div>
              </div>
            </div>
          // </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Contacts/index.js